import { Highlight } from '../Highlight';
import { fromCamelCaseToWords } from '../../misc/functions';
import { NO_DATA } from '../../misc/misc.constants';
import type { Filters, Website } from '../../types';

interface PagesCellProps {
  column: string;
  websiteData: Website;
  host: string;
  filters: Filters;
}

export function PagesCell({
  column,
  websiteData,
  host,
  filters,
}: PagesCellProps) {
  const pages = websiteData[column] as string[];

  return (
    <td data-title={fromCamelCaseToWords(column)} data-qa={column}>
      {pages.length ? (
        <ul>
          {pages.map((page) => (
            <li key={page}>
              <a
                href={`https://${host}/${page}`}
                target="_blank"
                rel="noreferrer"
              >
                <Highlight text={page} highlight={filters[column]} />
              </a>
            </li>
          ))}
        </ul>
      ) : (
        NO_DATA
      )}
    </td>
  );
}
